import { getUrl } from 'helpers';
import { useCallback, useEffect, useState } from 'react';
import { Container, Content, CopyButton, CopyButtonTooltip, ImageContainer, Link, Title } from './MobileWarning.styled';

export default function MobileWarning({ children, minWidth }: MobileWarningProps) {
    const [copied, setCopied] = useState(false);
    const [linkParts, setLinkParts] = useState(['', '']);
    const [visible, setVisible] = useState(window.innerWidth < minWidth);

    const handleResize = useCallback(() => {
        const newVisible = window.innerWidth < minWidth;
        setVisible(newVisible);
    }, [minWidth]);

    useEffect(() => {
        // Add listener
        window.addEventListener('load', handleResize);
        window.addEventListener('resize', handleResize);

        // Get link parts
        const link = `${window.location.hostname}${getUrl('')}`;
        const newLinkParts = ['', ''];
        link.split('/').forEach(segment => {
            const index = newLinkParts[0].length + segment.length < link.length / 2 ? 0 : 1;
            newLinkParts[index] += (index || newLinkParts[index].length ? '/' : '') + segment;
        });
        setLinkParts(newLinkParts);

        return () => {
            // Remove listener
            window.removeEventListener('resize', handleResize);
        };
    }, [handleResize]);

    function handleCopy() {
        void navigator.clipboard.writeText(`${window.location.origin}${process.env.NEXT_CONFIG_BASE_PATH}`);
        setCopied(true);
        setTimeout(() => setCopied(false), 3000);
    }

    if (!visible) {
        return children;
    }

    return (
        <Container>
            <Content>
                <Title>This game is optimized for screen sizes of ~{minWidth} pixels, try it on your desktop.</Title>
                <ImageContainer>
                    <picture>
                        <img
                            alt="Man sitting in front of a desktop computer"
                            src={getUrl('/assets/mobile-warning.png')}
                        />
                    </picture>
                </ImageContainer>
                <Link>
                    {linkParts[0]}
                    <br />
                    {linkParts[1]}
                </Link>
                <CopyButton onClick={handleCopy}>
                    <picture>
                        <img alt="Copy icon" src={getUrl('/assets/mobile-warning-copy.svg')} />
                    </picture>
                    {copied && <CopyButtonTooltip>Copied</CopyButtonTooltip>}
                </CopyButton>
            </Content>
        </Container>
    );
}
